import React from 'react';

interface CareProfileCardProps {
	id?: string;
	className?: string;
	children: React.ReactNode;
	padding?: 'sm' | 'md';
}

const paddingClassByVariant: Record<'sm' | 'md', string> = {
	sm: 'p-4',
	md: 'p-5',
};

const CareProfileCard: React.FC<CareProfileCardProps> = ({ id, className = '', children, padding = 'md' }) => (
	<div id={id} className={`rounded-2xl shadow-sm bg-white ${paddingClassByVariant[padding]} ${className}`}>
		{children}
	</div>
);

export default CareProfileCard;
